import { render, staticRenderFns } from "./DatasetsList.vue?vue&type=template&id=382066ea"
import script from "./DatasetsList.vue?vue&type=script&lang=js"
export * from "./DatasetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports